import React, { useState, useEffect } from "react";
import { Navbar, Modal, Container, Button } from "react-bootstrap";

export default function NavBar(props) {
  const [isLoggedIn, setLoggedState] = useState();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    setLoggedState(props.isLoggedIn);
  });

  const logOut = () => {
    localStorage.removeItem("userToken");
    window.location.reload();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Important Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Before logging out please take screenshot of the login credentials
          like PIN and ID {"{"}Red Box{"}"}.
          <br />
          <b>You need them to login again. PIN cannot be restored.</b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => logOut()}>
            Log out
          </Button>
        </Modal.Footer>
      </Modal>
      <Navbar expand="lg">
        <Container
          style={{ marginLeft: "10px", marginRight: "10px", width: "100vw" }}
        >
          <Navbar.Brand
            href="/"
            style={{ fontSize: "35px", fontWeight: "900", color: "#fff" }}
          >
            SecretSafe
          </Navbar.Brand>
        </Container>
        {isLoggedIn ? (
          <Button
            className="d-flex"
            onClick={() => handleShow()}
            variant="light"
            style={{
              alignItems: "center",
              marginRight: "15px",
              marginLeft: "15px",
            }}
          >
            Log Out
          </Button>
        ) : (
          <Button
            className="d-flex"
            variant="light"
            style={{
              alignItems: "center",
              marginRight: "15px",
              marginLeft: "15px",
            }}
            onClick={() => window.location.replace("/login")}
          >
            Login
          </Button>
        )}
      </Navbar>
    </>
  );
}
